import { render, staticRenderFns } from "./BiodigestorMonitoringWidgetComponent.vue?vue&type=template&id=aed6f01c&"
import script from "./BiodigestorMonitoringWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./BiodigestorMonitoringWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports